<template>
  <div>
    <slot name="export-button" :is-busy="isExporting" :sidebar-id="sidebarId">
      <b-button id="table-export" size="sm" class="mr-1" :disabled="isBusy || itemsCount === 0" variant="info" v-b-toggle="sidebarId">
        <font-awesome-icon icon="file-upload"/>
      </b-button>
      <b-tooltip target="table-export" triggers="hover" variant="info" noninteractive>
        Экспорт
      </b-tooltip>
    </slot>

    <portal to="app">
      <b-sidebar :id="sidebarId" class="export-sidebar" title="Экспорт" right shadow backdrop>
        <div class="px-1 py-1">
          <b-list-group-item
            v-for="(value, key) in localColumns"
            :key="key"
            bg-variant="light"
            class="d-flex justify-content-between align-items-center text-small px-2 py-2"
          >
            <div class="d-inline-flex align-items-center">
              {{ key }}
            </div>
            <b-form-checkbox
              v-model="localColumns[key]"
              stack
              switch
              class="ml-1"
            />
          </b-list-group-item>
          <br/>
          <b-button v-if="checkAllExport" size="sm" variant="secondary" @click="checkAllBoxes(false)">
            <font-awesome-icon :icon="['far', 'square']" class="mr-1"/>
            Снять все
          </b-button>
          <b-button v-else size="sm" variant="info" @click="checkAllBoxes(true)">
            <font-awesome-icon icon="check-square" class="mr-1"/>
            Выбрать все
          </b-button>
          <slot name="extra-buttons"></slot>
          <b-button size="sm" variant="success" @click="saveExportSettings()" class="ml-1">
            <font-awesome-icon icon="save" class="mr-1"/>
            Сохранить
          </b-button>
          <b-button size="sm" variant="primary" class="mt-1" @click="exportFile()" :disabled="isExporting">
            <b-spinner v-if="isExporting" small/>
            <font-awesome-icon v-else icon="file-upload" class="mr-1"/>
            Экспортировать
          </b-button>
        </div>
      </b-sidebar>
    </portal>
  </div>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  name: "ExportSidebar",
  props: {
    sidebarId: { type: String, required: true },
    storageKey: { type: String, required: true },
    columns: { type: Object, required: true },
    dataToExport: { type: Array, required: false, default: () => [] },
    dataProvider: { type: Function, required: false, default: null },
    dataMapper: { type: Function, required: true },
    fileName: { type: String, required: true },
    sheetName: { type: String, default: "Лист-1" },
    isBusy: { type: Boolean, default: false },
    itemsCount: { type: Number, default: 0 }
  },
  data() {
    return {
      isExporting: false,
      localColumns: {},
      checkAllExport: true,
    };
  },
  created() {
    this.localColumns = { ...this.columns };
    this.getExportSettings();
  },
  methods: {
    checkAllBoxes(flag) {
      for (const key in this.localColumns) {
        this.localColumns[key] = flag;
      }
    },
    updateCheckAllFlag() {
      const keys = Object.keys(this.localColumns);
      if (keys.length === 0) {
        this.checkAllExport = false;
        return;
      }
      const selectedCount = keys.filter(key => this.localColumns[key]).length;
      this.checkAllExport = selectedCount === keys.length;
    },
    getExportSettings() {
      const storedData = localStorage.getItem(this.storageKey);
      if (storedData) {
        const storedConfig = JSON.parse(storedData);

        for (const key in this.localColumns) {
          if (storedConfig.hasOwnProperty(key)) {
            this.localColumns[key] = storedConfig[key];
          }
        }
      }
      this.updateCheckAllFlag();
    },
    saveExportSettings() {
      const storedData = localStorage.getItem(this.storageKey);
      const storedConfig = storedData ? JSON.parse(storedData) : {};
      const updatedSettings = { ...storedConfig, ...this.localColumns };

      localStorage.setItem(this.storageKey, JSON.stringify(updatedSettings));
      this.$bvToast.toast("Настройки экспорта сохранены.", {
        title: 'Сохранено',
        variant: 'success',
        autoHideDelay: 3000,
        solid: true
      });
    },
    async exportFile() {
      if (!Object.values(this.localColumns).some(value => value === true)) {
        this.$bvToast.toast("Выберите данные для экспорта.", { title: 'Ошибка', variant: 'danger' });
        return;
      }

      this.isExporting = true;
      let itemsToExport = [];

      itemsToExport = this.dataProvider ? await this.dataProvider(this.localColumns) : this.dataToExport;

      if (!itemsToExport || itemsToExport.length === 0) {
        this.$bvToast.toast("Данные для экспорта не найдены.", { title: 'Ошибка', variant: 'danger' });
        return;
      }

      const mappedData = itemsToExport.reduce((acc, item) => {
        const mappedItems = this.dataMapper(item, this.localColumns);
        return acc.concat(mappedItems);
      }, []);

      let worksheet = XLSX.utils.json_to_sheet(mappedData);
      let workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, this.sheetName);
      XLSX.writeFile(workbook, this.fileName);
      this.isExporting = false;
    },
  },
  watch: {
    localColumns: {
      handler() {
        this.updateCheckAllFlag();
      },
      deep: true,
    },
    columns: {
      handler(newValue) {
        const updatedLocalColumns = {};
        for (const key in newValue) {
          if (this.localColumns.hasOwnProperty(key)) {
            updatedLocalColumns[key] = this.localColumns[key];
          } else {
            updatedLocalColumns[key] = newValue[key];
          }
        }
        this.localColumns = updatedLocalColumns;
        this.getExportSettings();
      },
      deep: true
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/utilites/commonUi/ExportSidebar.vue